import type { ReactNode } from 'react';
import { css, cx } from 'styled-system/css';

export function Container({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cx(
        css({
          maxWidth: 'content',
          marginInline: 'auto',
          paddingInline: { base: '5', md: '8' },
        }),
        className,
      )}
    >
      {children}
    </div>
  );
}
